var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('div',{ref:"ffo1",attrs:{"id":"ffo1"}}):_c('no-data-temporarily',{staticClass:"flex-grow-1"})}
var staticRenderFns = []

export { render, staticRenderFns }